import {
  fetchIntegration,
  integrationUpdatedNotification,
} from 'common/actions/integrations/common/actions/integrationActions'

const initialState = {}

function integrationsReducer(state = initialState, action) {
  switch (action.type) {
    case fetchIntegration.fulfilled.type:
    case integrationUpdatedNotification.type: {
      const { integration, statistics } = action.payload

      const permission = action.permission
      const permissions = permission ? permission : undefined

      return { ...state, ...integration, permissions, statistics }
    }
  }
  return state
}

export default function makeIntegrationsReducer(reducer, integration) {
  return (state, action) => {
    const type = action?.payload?.integration?.type
    if (type === integration) {
      state = integrationsReducer(state, action)
    }
    return reducer(state, action)
  }
}
